<template>
	<div>
		<div>登录即代表您已详细阅读，理解并同意<span class="protocol theme-color" @click.prevent="getProtocol('user')">《{{siteCfg?siteCfg.app_name:''}}用户协议》</span>
					与<span class="protocol theme-color" @click.prevent="getProtocol('privacy')">《{{siteCfg?siteCfg.app_name:''}}隐私政策》</span></div>
		<el-dialog :visible.sync="show" :title="protocolType[type]" destroy-on-close append-to-body :modal="false">
			<div class="content" v-html="content"></div>
		</el-dialog>
	</div>
</template>
<script>
import {protocolDetail} from '@/api/public'
const protocolType = {
	user: '用户协议',
	privacy: '隐私政策'
}
export default {
	data() {
		return {
			protocolType,
			type: 'user',
			show: false,
			content: '',
			isLoading: false
		}
	},
	computed: {
		siteCfg() {
			return this.$store.getters.config
		}
	},
	methods: {
		getProtocol(type) {
			if(this.isLoading) return
			this.type = type
			this.isLoading = true
			protocolDetail({
				type: type == 'user' ? 'agreement' : 'privacy'
			}).then(res => {
				const {content=''} = res.data
				this.content = content
				this.show = true
				this.isLoading = false
			}).catch(() => {
				this.isLoading = false
			})
		}
	}
}
</script>
<style lang="scss" scoped>
.content {
	max-height: 500px;
	overflow: auto;
}
</style>